import { UserContext } from 'Contexts/UserContext/UserContext'
import React, { useContext, useState, useEffect } from 'react'
import Script from 'next/script'
import { TrackingContext } from 'Contexts/TrackingContext/TrackingContext'
import useGlobalPrivacyControl from "Hooks/useGlobalPrivacyControl";

export default function BloomreachPixelTracking() {
    const { context: userContext } = useContext(UserContext)
    const trackingContext = useContext(TrackingContext)
    const [render, setrender] = useState(false)
    const { isGpcEnabled } = useGlobalPrivacyControl();

    const bloomreachDoneHandler = (e) => {
        if (typeof window.BrTrk === "undefined") console.error("Bloomreach is not ready")
        trackingContext.setBloomReachReady()
    };

    useEffect(() => {
        window.addEventListener("bloomreachLoaded", bloomreachDoneHandler);
        return () => {
            window.removeEventListener("bloomreachLoaded", bloomreachDoneHandler);
        };
    }, [])

    useEffect(() => {
        // we don't want to render the bloomreach pixel for bot visitiors
        // for the initial load of the bloomreach script, the br_data object must be set up       
        // (see https://documentation.bloomreach.com/discovery/docs/global-page-view-pixel)
        // this is being done in the useBloomreach.sendBloomreachInitialPageView function
        const shouldRender = userContext && !userContext.isBot() && trackingContext?.shouldRenderBloomreach
        if (shouldRender) {
            setrender(true)
        }
    }, [(userContext ? userContext.hydrated : false) && trackingContext?.shouldRenderBloomreach, isGpcEnabled])

    if (!render) {
        return false
    }

    return (
        <Script
            enableOnlyOnNextFrontEnd={true}
            id="bloomreachTracking-init"
            data-testid="bloomreachTracking-init"
            strategy="afterInteractive"
            src="https://cdn.brcdn.com/v1/br-trk-6357.js"
            onLoad={() => {
                try {
                    window.dispatchEvent(new CustomEvent('bloomreachLoaded', null))
                }
                catch (err) {
                    console.error('onLoad for bloomreach failed', err)
                }
            }
            }>

        </Script>

    )
}
